import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const TemplatesVisualizationsApiSlice = apiSlice.injectEndpoints({
  tagTypes: [ 'TemplatesVisualizations', 'TemplatesVisualizationItem' ],
  endpoints: (builder) => {
    return ({
      getTemplatesVisualizations: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/templates/visualizations${queryParams}` });
        },
        transformResponse: (response) => {
          return {
            data: response?.data,
            pagination: response?.meta?.pagination,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'TemplatesVisualizations' ],
        keepUnusedDataFor: 1,
      }),
      getTemplatesVisualization: builder.query({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/visualizations/${id}`,
          method: 'GET',
        }),
        transformResponse: (response) => {
          return { data: response?.data };
        },
        providesTags: [ 'TemplatesVisualizationItem' ],
        keepUnusedDataFor: 1,
      }),
      createTemplatesVisualization: builder.mutation({
        query: ({ values }) => {
          return ({
            url: `/${Config.VITE_HC_API_VERSION}/templates/visualizations`,
            method: 'POST',
            body: values,
          });
        },
        invalidatesTags: () => [ 'TemplatesVisualizations' ],
      }),
      updateTemplatesVisualization: builder.mutation({
        query: ({ id, values }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/visualizations/${id}`,
          method: 'PUT',
          body: values,
        }),
        invalidatesTags: () => [ 'TemplatesVisualizations', 'TemplatesVisualizationItem' ],
      }),
      deleteTemplatesVisualization: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/visualizations/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ 'TemplatesVisualizations' ],
      }),
    });
  },
});

export const {
  useGetTemplatesVisualizationsQuery,
  useGetTemplatesVisualizationQuery,
  useCreateTemplatesVisualizationMutation,
  useUpdateTemplatesVisualizationMutation,
  useDeleteTemplatesVisualizationMutation,
} = TemplatesVisualizationsApiSlice;
